import { z } from 'zod';
import { api } from './api';
import {
  integrationDetailSchema,
  integrationSchema,
  reconciliationSchema,
  type Integration,
  type IntegrationDetail,
  type Reconciliation,
} from '@/types/integration';

export const integrationsService = {
  list: (signal?: AbortSignal): Promise<Integration[]> =>
    api.get('/integrations', z.array(integrationSchema), signal),

  iiko: (signal?: AbortSignal): Promise<IntegrationDetail> =>
    api.get('/integrations/iiko', integrationDetailSchema, signal),

  reconciliation: (year?: number, month?: number, signal?: AbortSignal): Promise<Reconciliation> =>
    api.get(
      `/integrations/iiko/reconciliation${year && month ? `?year=${year}&month=${month}` : ''}`,
      reconciliationSchema,
      signal,
    ),
};
